"use client";

// src/components/appstores/appstores.tsx
import { tv } from "tailwind-variants";
import { Link } from "../link/link.mjs";
import { AppleStoreIcon } from "./apple-store-icon.mjs";
import { GooglePlayStoreIcon } from "./google-play-store-icon.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
var style = tv({ base: "flex gap-4 p-1 items-center" });
function AppStores({
  appleHref,
  googleHref,
  className,
  track
}) {
  return /* @__PURE__ */ jsxs("div", { className: style({ className }), children: [
    /* @__PURE__ */ jsx(
      Link,
      {
        href: appleHref,
        target: "_blank",
        "aria-label": "Download on the Apple Store",
        track,
        children: /* @__PURE__ */ jsx(AppleStoreIcon, {})
      }
    ),
    /* @__PURE__ */ jsx(
      Link,
      {
        href: googleHref,
        target: "_blank",
        "aria-label": "Get it on Google Play",
        track,
        children: /* @__PURE__ */ jsx(GooglePlayStoreIcon, {})
      }
    )
  ] });
}
export {
  AppStores
};
